import React, { Component } from 'react'
import PageWrapper from '../../helper/PageWrapper'
import camK1 from '../../img/k1.png'
import camK1_K2 from '../../img/k2_.png'
import camK2M from '../../img/k2m.png'
import camIp from '../../img/ip.png'
import camK2X from '../../img/k2x.png'
import i18n from '../../languages/i18n'
import AiswSpinner from '../helper/aiswSpinner/aiswSpinner'
import plusIcon from '../../img/icons/plus.svg'
import editIcon from '../../img/icons/edit.svg'
import deleteIcon from '../../img/icons/delete.svg'
import StaigeButton from '../../components/styles/Button'
import StaigeBadge from '../../components/styles/Badge'
import mobiscroll from '@mobiscroll/react'
import StaigeModal from '../../components/styles/Modal'
import SoundControll, { SoundControllRef } from '../../components/camera/SoundControll' // Added SoundControllRef import
import HeatControll, { HeatControllRef } from '../../components/camera/HeatControll'

import contractContainer, { ContractContainer } from '../../services/contractContainer'
import { CameraData, Role } from '@soccerwatch/common'
import { CameraContainer } from '../../services/cameraContainer'
import { RouteComponentProps } from 'react-router-dom'
import { withRouter } from 'react-router'
import { searchAndSortGetCallAs } from '../../services/serviceHelper'
import {
  CameraStatusDetail,
  CameraStatusResponse,
  deleteCameraCornerPoints,
  getCameraCornerPointsAll,
  postCameraSpeedTest,
  postCameraStatus,
  postCameraStop
} from '../../api/api-camera'
import { isAxiosError } from '../../helper/UtilityFunctions'

import './Camera.scss'
import { postCameraAutofocus } from '../../api/api-pluto'
import { postCameraCalibration, getCameraCalibrationStatus } from '../../api/backstaige_v2'
import { StichingStatus } from '../../types/StichingStatus'
import { findSupportedSoundCard } from '../../config/soundCards'
import moment from 'moment'
import 'moment/locale/de'

const camN6 = `${process.env.PUBLIC_URL}/img/N6-Titelbild.png`

type fieldmasks = Array<{
  fieldName: string
  fieldCorners: number[]
}>

type Task = {
  status: { status: number }
  gameId: string
  startTime?: string
  endTime?: string
  type?: string
}

type StatusIndicatorColor = 'green' | 'red' | 'yellow'

type StatusIndicator = {
  label: string
  value: string
  color: StatusIndicatorColor
}

type CameraMonitorStateType = {
  camera: CameraData | undefined
  tasks: Array<Task>
  tasksRemoved: { [id: string]: boolean }
  cameraStatus: CameraStatusResponse | null
  statusRefreshing: boolean
  loadingData: boolean
  speedTestIsRunning: boolean
  speedTestFailed: boolean
  cameraNetworkSpeed?: number
  loadingFields: boolean
  fieldmasks: fieldmasks
  loadingDelete: Array<string>
  loadingAutofocus: boolean
  calibrationStatus: StichingStatus | null
  calibrationLoading: boolean
  calibrationTick: number
}

type CameraMonitorPropsType = RouteComponentProps & {
  id?: number | null
  cameraContainer: CameraContainer
  contractContainer: ContractContainer
}

class CameraMonitor extends Component<CameraMonitorPropsType, CameraMonitorStateType> {
  popup = React.createRef<any>()
  private pollingTimeouts: { [gameId: string]: number } = {}
  private statusInterval: number | null = null
  private calibrationInterval: number | null = null
  private calibrationTickInterval: number | null = null

  constructor(props: CameraMonitorPropsType) {
    super(props)
    this.state = {
      camera: undefined,
      tasks: [],
      tasksRemoved: {},
      cameraStatus: null,
      statusRefreshing: false,
      loadingData: true,
      speedTestIsRunning: false,
      cameraNetworkSpeed: undefined,
      speedTestFailed: false,
      loadingFields: true,
      fieldmasks: [],
      loadingDelete: [],
      loadingAutofocus: false,
      calibrationStatus: null,
      calibrationLoading: false,
      calibrationTick: 0
    }
  }

  private readonly refConfirmDeleteModal = React.createRef<any>()
  private readonly refAutofocus = React.createRef<any>()
  private readonly refCalibrate = React.createRef<any>()
  private readonly refStopRec = React.createRef<any>()

  private readonly refSoundControll = React.createRef<SoundControllRef>() // Updated ref type
  private readonly refHeatControll = React.createRef<HeatControllRef>()

  getCurrentCamera = (id: string) => {
    return this.props.cameraContainer
      .getCameraListForCurrentContract()
      .filter((cam: CameraData) => cam.RowKey === id)[0]
  }

  componentDidMount() {
    this.getCornerPoints(String(this.props.id))

    this.getCameraStatus()
    // Set up interval for status updates
    this.statusInterval = window.setInterval(() => {
      if (this.state.camera?.hardwarePlatform?.includes('pluto')) {
        this.getCameraStatus()
      }
    }, 60000)

    const camera = this.getCurrentCamera(String(this.props.id))
    this.setState({
      camera,
      loadingData: this.props.cameraContainer.state.loadingData
    })

    // Kalibrierungsstatus: für alle Kameras, Polling alle 30s, Tick alle 1s
    if (camera?.RowKey) {
      this.calibrationInterval = window.setInterval(() => this.fetchCalibrationStatus(), 30000)
      this.calibrationTickInterval = window.setInterval(
        () => this.setState({ calibrationTick: Date.now() }),
        1000
      )
      setTimeout(() => this.fetchCalibrationStatus(), 100)
    }
  }

  componentWillUnmount() {
    Object.values(this.pollingTimeouts).forEach(clearTimeout)
    if (this.statusInterval) {
      clearInterval(this.statusInterval)
    }
    if (this.calibrationInterval) {
      clearInterval(this.calibrationInterval)
    }
    if (this.calibrationTickInterval) {
      clearInterval(this.calibrationTickInterval)
    }
  }

  componentDidUpdate(prevProps: CameraMonitorPropsType) {
    if (
      this.props.cameraContainer.state.loadingData !== this.state.loadingData &&
      this.props.contractContainer.state.loadingData !== this.state.loadingData
    ) {
      this.setState({
        loadingData: this.props.cameraContainer.state.loadingData
      })
    }

    const cam = this.getCurrentCamera(String(this.props.id))
    if (JSON.stringify(cam) !== JSON.stringify(this.state.camera)) {
      this.setState({
        camera: cam
      })
    }
  }

  getCornerPoints = async (camId: string) => {
    try {
      const callAs = searchAndSortGetCallAs([
        Role.admin,
        contractContainer.getHighestRelevantRoleForCurrentContract()
      ])
      const res = await getCameraCornerPointsAll(camId, callAs)
      if (res.status === 200) {
        const fieldmasks: fieldmasks = []
        res.data.forEach((dataset) => {
          fieldmasks.push({ fieldName: dataset.fieldName, fieldCorners: dataset.Corners.corners })
        })

        this.setState({ fieldmasks: fieldmasks, loadingFields: false })
        return
      }
      console.warn('Get Cornerpoints for', camId, ' Failed with Status', res.status)
      this.setState({ loadingFields: false })
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        console.warn('Get Cornerpoints for', camId, ' Failed with Status', err.response?.status)
      } else {
        console.warn('An unknown error occurred:', err)
      }
      this.setState({ loadingFields: false })
    }
  }

  showPopup = () => {
    if (!this.state.speedTestIsRunning) {
      this.startSpeedTest()
    }
    this.popup.current?.instance.show()
  }

  updateSpeedTest = async (
    cameraID: number,
    onFinished: (uploadSpeed: number) => void,
    onError: (data: unknown) => void
  ) => {
    const callAs = searchAndSortGetCallAs([
      Role.admin,
      contractContainer.getHighestRelevantRoleForCurrentContract()
    ])
    const data = await postCameraSpeedTest(cameraID, callAs)

    if (data.success && typeof data.detail !== 'string') {
      if (data.detail.speedtest === 'finished' && data.detail.upload_speed_mbit) {
        onFinished(data.detail.upload_speed_mbit)
      } else {
        setTimeout(() => this.updateSpeedTest(cameraID, onFinished, onError), 3000)
      }
    } else {
      onError(data)
    }
  }

  executeSpeedTest = (cameraID: number): Promise<number> => {
    return new Promise((resolve, reject) => {
      this.updateSpeedTest(cameraID, resolve, reject)
    })
  }

  startSpeedTest = async () => {
    this.setState({
      speedTestIsRunning: true
    })

    try {
      const speed = await this.executeSpeedTest(Number(this.props.id))
      this.setState({
        speedTestIsRunning: false,
        cameraNetworkSpeed: speed
      })
    } catch (e) {
      console.error(e)
      this.setState({ speedTestIsRunning: false, speedTestFailed: true })
    }
  }

  getCamerImg = (camera?: CameraData) => {
    if (camera === undefined) {
      return <img src={camK2M} />
    }

    const hardwarePlatform = (camera.hardwarePlatform ?? '').toLowerCase()
    if (hardwarePlatform.includes('n6')) {
      return <img src={camN6} />
    }

    let cameraImg
    switch (hardwarePlatform) {
      case 'ip':
      case 'qube':
        cameraImg = <img src={camIp} />
        break
      case 'k1':
        cameraImg = <img src={camK1} />
        break
      case 'k2m':
        cameraImg = <img src={camK2M} />
        break
      case 'k2x':
        cameraImg = <img src={camK2X} />
        break
      default:
        cameraImg = <img src={camK1_K2} />
        break
    }
    return cameraImg
  }

  renderFieldMaskItem(def: boolean, name: string) {
    const defaultItem = def
    return (
      <div key={name} className={`list-fieldmaskItem ${defaultItem ? 'list-fieldmaskItemDefault' : ''}`}>
        {this.state.loadingDelete.find((n) => n === name) ? (
          <div className='fieldmaskItem-delete'>
            <AiswSpinner />
          </div>
        ) : null}

        <div className='fieldmaskItem-content'>
          <div className='content-header'>
            {defaultItem ? (
              <>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                >
                  <mask id='mask0_1237_149767' maskUnits='userSpaceOnUse' x='0' y='0' width='16' height='16'>
                    <rect width='16' height='16' fill='#D9D9D9' />
                  </mask>
                  <g mask='url(#mask0_1237_149767)'>
                    <path
                      d='M7.99935 15.3335L3.19935 11.7335C3.03268 11.6113 2.90213 11.4557 2.80768 11.2668C2.71324 11.0779 2.66602 10.8779 2.66602 10.6668V2.66683C2.66602 2.30016 2.79657 1.98627 3.05768 1.72516C3.31879 1.46405 3.63268 1.3335 3.99935 1.3335H11.9993C12.366 1.3335 12.6799 1.46405 12.941 1.72516C13.2021 1.98627 13.3327 2.30016 13.3327 2.66683V10.6668C13.3327 10.8779 13.2855 11.0779 13.191 11.2668C13.0966 11.4557 12.966 11.6113 12.7993 11.7335L7.99935 15.3335ZM7.99935 13.6668L11.9993 10.6668V2.66683H3.99935V10.6668L7.99935 13.6668ZM7.29935 10.0002L11.066 6.2335L10.1327 5.26683L7.29935 8.10016L5.89935 6.70016L4.93268 7.6335L7.29935 10.0002Z'
                      fill='#FF3517'
                    />
                  </g>
                </svg>
                <div className='header-defaultText'>{i18n.t('camera.fieldmaskDefault')}</div>
              </>
            ) : (
              <div className='header-normalText'>{i18n.t('camera.fieldmaskOptinal')}</div>
            )}
          </div>
          <div className='content-title'>{name}</div>
        </div>
        <div className='fieldmaskItem-action'>
          <StaigeButton
            style='ghost'
            icon={editIcon}
            iconMargin='0 -4px 0 -4px'
            linkTo={`/cameramonitor/liveview/${this.props.id}/${defaultItem ? 'default' : name}`}
          />
          {defaultItem ? null : (
            <StaigeButton
              style='ghost'
              icon={deleteIcon}
              iconMargin='0 -4px 0 -4px'
              onClick={() => this.refConfirmDeleteModal.current.handleOpenModal(name)}
            />
          )}
        </div>
      </div>
    )
  }

  deleteField = async (fieldName?: string) => {
    if (fieldName === undefined) return
    if (fieldName === 'default') {
      return
    }
    this.setState({ loadingDelete: [...this.state.loadingDelete, fieldName] })
    const callAs = searchAndSortGetCallAs([
      Role.admin,
      contractContainer.getHighestRelevantRoleForCurrentContract()
    ])
    const res = await deleteCameraCornerPoints(String(this.props.id), fieldName, callAs)
    if (res.status !== 200) {
      const newLoadingDelete = this.state.loadingDelete.filter((e) => e !== fieldName)
      this.setState({
        loadingDelete: newLoadingDelete
      })
      console.error('Could not Delete Field:', res)
      return
    }

    const newLoadingDelete = this.state.loadingDelete.filter((e) => e !== fieldName)
    const fieldmasksRemove = this.state.fieldmasks.filter((field) => field.fieldName !== fieldName)
    this.setState({
      loadingDelete: newLoadingDelete,
      fieldmasks: fieldmasksRemove
    })
  }

  handleAutofocus = async () => {
    this.setState({ loadingAutofocus: true })
    const callAs = searchAndSortGetCallAs([
      Role.admin,
      contractContainer.getHighestRelevantRoleForCurrentContract()
    ])
    await postCameraAutofocus(String(this.props.id), callAs)
    this.setState({ loadingAutofocus: false })
    this.refAutofocus.current.handleCloseModal()
  }

  handleCalibrate = async () => {
    const callAs = searchAndSortGetCallAs([
      Role.admin,
      contractContainer.getHighestRelevantRoleForCurrentContract()
    ])
    postCameraCalibration(String(this.props.id), callAs)
  }

  fetchCalibrationStatus = async () => {
    const cameraId = this.state.camera?.RowKey
    if (!cameraId) return
    this.setState({ calibrationLoading: true })
    try {
      const res = await getCameraCalibrationStatus(cameraId)
      this.setState({ calibrationStatus: res.data, calibrationLoading: false })
    } catch (err) {
      console.warn('Kalibrierungsstatus konnte nicht geladen werden:', err)
      this.setState({ calibrationLoading: false })
    }
  }

  getCameraStatusDetail = (): CameraStatusDetail | null => {
    if (!this.state.cameraStatus?.detail || typeof this.state.cameraStatus.detail === 'string') {
      return null
    }
    return this.state.cameraStatus.detail
  }

  getPlutoIndicators = (): StatusIndicator[] => {
    const detail = this.getCameraStatusDetail()
    const gpuCount = detail?.gpuNames?.length ?? 0
    const reportedSoundCardNames = detail?.soundCardNames ?? []
    const detectedSoundCard = findSupportedSoundCard(reportedSoundCardNames)
    const reachableCamCount = detail?.reachableCams?.length ?? 0
    const rawStatus = this.state.cameraStatus as unknown as {
      sound?: Array<{ channels?: Array<{ muted?: boolean }> }>
      detail?: { sound?: Array<{ channels?: Array<{ muted?: boolean }> }> }
    } | null
    const soundControls = detail?.sound ?? rawStatus?.detail?.sound ?? rawStatus?.sound ?? []
    const availableAudioChannels = soundControls.reduce(
      (sum, control) => sum + (control.channels?.length ?? 0),
      0
    )
    const hasAudioDevice = Boolean(detectedSoundCard)
    const expectedChannels = detectedSoundCard?.expectedChannels ?? 10
    const syncEntry = detail?.argoCDSyncStatus?.[0]
    const resources = syncEntry?.resources ?? []
    const resourcesWithKnownStatus = resources.filter((resource) => resource.syncStatus !== undefined)
    const totalServices = resourcesWithKnownStatus.length
    const syncedServices = resourcesWithKnownStatus.filter(
      (resource) => resource.syncStatus === 'Synced'
    ).length
    const allServicesSynced = totalServices > 0 && syncedServices === totalServices
    const syncRatio = `${syncedServices}/${totalServices}`
    const showSyncOk = allServicesSynced
    const syncValue = showSyncOk ? `OK (${syncRatio})` : syncRatio

    return [
      { label: 'GPU', value: gpuCount > 0 ? 'OK' : 'N/A', color: gpuCount > 0 ? 'green' : 'red' },
      {
        label: 'Audio',
        value: detectedSoundCard?.displayName ?? 'N/A',
        color: hasAudioDevice ? 'green' : 'red'
      },
      {
        label: 'S/PDIF',
        value: hasAudioDevice ? `${availableAudioChannels}/${expectedChannels}` : 'Kein Audio-Device',
        color: !hasAudioDevice ? 'yellow' : availableAudioChannels === expectedChannels ? 'green' : 'red'
      },
      {
        label: 'CAM',
        value: String(reachableCamCount),
        color: reachableCamCount > 0 ? 'green' : 'red'
      },
      { label: 'SYNC', value: syncValue, color: showSyncOk ? 'green' : 'red' }
    ]
  }

  getUnsyncedServices = (): Array<{ name: string; status: string }> => {
    const detail = this.getCameraStatusDetail()
    const syncEntry = detail?.argoCDSyncStatus?.[0]
    const resources = syncEntry?.resources ?? []
    const resourcesWithKnownStatus = resources.filter((resource) => resource.syncStatus !== undefined)
    const syncedServices = resourcesWithKnownStatus.filter(
      (resource) => resource.syncStatus === 'Synced'
    ).length
    const allServicesSynced =
      resourcesWithKnownStatus.length > 0 && syncedServices === resourcesWithKnownStatus.length
    if (allServicesSynced) {
      return []
    }
    return resourcesWithKnownStatus
      .filter((resource) => resource.syncStatus !== 'Synced')
      .slice(0, 3)
      .map((resource) => ({
        name: resource.name || resource.kind || 'Unknown service',
        status: resource.syncStatus || 'Unknown'
      }))
  }

  getCameraStatus = async () => {
    this.setState({ statusRefreshing: true })
    const callAs = searchAndSortGetCallAs([
      Role.admin,
      contractContainer.getHighestRelevantRoleForCurrentContract()
    ])
    try {
      const tasksResponse = await postCameraStatus(String(this.props.id), callAs)
      let newTasks: Task[] = []
      if (tasksResponse?.detail && typeof tasksResponse.detail !== 'string' && tasksResponse.detail.tasks) {
        newTasks = tasksResponse.detail.tasks.filter(
          (task: Task) => task.status.status === 1 || task.status.status === 2 || task.status.status === 3
        )
      }
      this.setState({ tasks: newTasks, cameraStatus: tasksResponse }, () => {
        this.checkTasksAndPoll()
      })
    } catch (error) {
      console.error('Failed to get camera status:', error)
      this.setState({ tasks: [], cameraStatus: null }, () => {
        this.checkTasksAndPoll()
      })
    } finally {
      this.setState({ statusRefreshing: false })
    }
  }

  checkTasksAndPoll = () => {
    if (!this.state.tasks || !this.state.tasksRemoved) {
      return
    }

    const tasksFromState = this.state.tasks
    const activeTaskIdsInState = new Set(tasksFromState.map((t) => t.gameId))
    let tasksRemovedUpdates: Record<string, boolean> | null = null

    Object.keys(this.state.tasksRemoved).forEach((gameId) => {
      if (this.state.tasksRemoved[gameId] === true) {
        if (this.pollingTimeouts[gameId]) {
          clearTimeout(this.pollingTimeouts[gameId])
          delete this.pollingTimeouts[gameId]
        }

        if (activeTaskIdsInState.has(gameId)) {
          this.pollingTimeouts[gameId] = window.setTimeout(() => {
            this.getCameraStatus()
          }, 5000)
        } else {
          if (!tasksRemovedUpdates) {
            tasksRemovedUpdates = {}
          }
          tasksRemovedUpdates[gameId] = false
        }
      }
    })

    if (tasksRemovedUpdates) {
      this.setState((prevState) => ({
        tasksRemoved: {
          ...prevState.tasksRemoved,
          ...tasksRemovedUpdates
        }
      }))
    }
  }

  render() {
    if (this.state.loadingData) {
      return (
        <PageWrapper
          headerTitle={`${i18n.t('camera.headerTitleLoad')} ${this.props.id}`}
          linkTo='/cameramonitor'
        >
          <div style={{ width: '100%', height: '100%' }}>
            <AiswSpinner />
          </div>
        </PageWrapper>
      )
    }

    if (!this.state.loadingData && this.state.camera === undefined) {
      return (
        <PageWrapper
          headerTitle={`${i18n.t('camera.headerTitleLoad')} ${this.props.id}`}
          linkTo='/cameramonitor'
        >
          <div className='page-cameraErr'>
            {i18n.t('camera.err')} <br />
            {i18n.t('camera.errText')}
          </div>
        </PageWrapper>
      )
    }

    const cameraStatusDetail = this.getCameraStatusDetail()
    const plutoIndicators = this.getPlutoIndicators()
    const unsyncedServices = this.getUnsyncedServices()
    const hwPlatform = (this.state.camera?.hardwarePlatform ?? '').toLowerCase()
    const showN6CalibrationMask =
      (hwPlatform.includes('n6') || hwPlatform.includes('n4')) && !hwPlatform.includes('k2')

    return (
      <PageWrapper
        headerTitle={`${i18n.t('camera.headerTitle')} ${this.state.camera?.hardwarePlatform} - ${
          this.state.camera?.RowKey
        }`}
        linkTo='/cameramonitor'
      >
        <StaigeModal
          ref={this.refConfirmDeleteModal}
          onConfirm={this.deleteField}
          confirmText={i18n.t('general.delete') + ' ' + i18n.t('general.confirm')}
          title={i18n.t('camera.deleteModal.title')}
          text={i18n.t('camera.deleteModal.text')}
        />
        <StaigeModal
          ref={this.refAutofocus}
          onConfirm={this.handleAutofocus}
          confirmText={i18n.t('general.confirm')}
          title={i18n.t('Autofocus')}
          text={
            !this.state.loadingAutofocus
              ? i18n.t('Möchtest du denn Autofocus Starten?')
              : i18n.t('Autofocus wird durchgeführt')
          }
          onConfirmCloseModalDisable
          disabledConfirm={this.state.loadingAutofocus}
        >
          {this.state.loadingAutofocus ? <AiswSpinner></AiswSpinner> : null}
        </StaigeModal>
        <StaigeModal
          ref={this.refCalibrate}
          onConfirm={this.handleCalibrate}
          confirmText={i18n.t('general.confirm')}
          title={i18n.t('Kalibrierung')}
          text={i18n.t('Die Kalibrierung kann bis zu 5min dauern')}
        />
        <StaigeModal
          ref={this.refStopRec}
          confirmText={i18n.t('general.confirm')}
          title={i18n.t('Kamera Aufnahme stoppen')}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {this.state.tasks?.length === 0 ? (
              <div style={{ padding: '26px 12px 12px 12px', textAlign: 'center' }}>
                Keine Aktiven Tasks gefunden
              </div>
            ) : null}

            {this.state.tasks?.map((itm) => {
              return (
                <div
                  key={itm.gameId}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    padding: '4px 12px'
                  }}
                >
                  <div>{itm.gameId}</div>
                  <StaigeButton
                    label='Stop'
                    style={this.state.tasksRemoved[itm.gameId] ? 'primary' : 'danger-secondary'}
                    disabled={this.state.tasksRemoved[itm.gameId]}
                    onClick={async () => {
                      const callAs = searchAndSortGetCallAs([
                        Role.admin,
                        contractContainer.getHighestRelevantRoleForCurrentContract()
                      ])
                      await postCameraStop(String(this.props.id), itm.gameId, callAs)

                      this.setState((prevState) => ({
                        tasksRemoved: {
                          ...prevState.tasksRemoved,
                          [itm.gameId]: true
                        }
                      }))
                      await this.getCameraStatus()
                    }}
                  />
                </div>
              )
            })}
          </div>
        </StaigeModal>

        {this.state.camera?.RowKey && (
          <SoundControll
            cameraId={this.state.camera.RowKey}
            ref={this.refSoundControll}
            soundSettings={cameraStatusDetail?.sound}
          />
        )}

        {this.state.camera?.RowKey && (
          <HeatControll
            cameraId={this.state.camera.RowKey}
            reachableCams={cameraStatusDetail?.reachableCams ?? []}
            ref={this.refHeatControll}
          />
        )}

        <div className='page-camera'>
          <div className='camera-container'>
            <div className='container-action'>
              {this.state.camera?.hardwarePlatform?.includes('pluto') ? (
                <>
                  <StaigeButton
                    label='Sound'
                    style='secondary'
                    onClick={async () => {
                      if (this.refSoundControll.current) {
                        this.refSoundControll.current.handleOpenSoundControllModal()
                      }
                    }}
                  />
                  <StaigeButton
                    label='Heater'
                    style='secondary'
                    onClick={() => {
                      if (this.refHeatControll.current) {
                        this.refHeatControll.current.handleOpenHeatControllModal()
                      }
                    }}
                  />
                  <StaigeButton
                    label='Tasks Stoppen'
                    style='secondary'
                    onClick={async () => {
                      this.refStopRec.current.handleOpenModal()
                      await this.getCameraStatus()
                    }}
                  />
                  <StaigeButton
                    label='Autofocus'
                    style='secondary'
                    onClick={() => this.refAutofocus.current.handleOpenModal()}
                  />
                  <StaigeButton
                    label='Kalibrierung'
                    style='secondary'
                    onClick={() => this.refCalibrate.current.handleOpenModal()}
                  />
                </>
              ) : (
                <StaigeButton label='Speedtest' style='ghost' onClick={this.showPopup} />
              )}
            </div>
            <div className='container-content'>
              <div className='content-column01'>
                <div className='column01-top'>
                  <div className='top-title'>{i18n.t('camera.fieldmask')}</div>
                  <div className='column01-top-buttons'>
                    {showN6CalibrationMask ? (
                      <StaigeButton
                        label={i18n.t('camera.calibrationMaskBtn')}
                        style='ghost'
                        icon={plusIcon}
                        iconMargin='0 0 0 -4px'
                        linkTo={`/cameramonitor/calibration-mask/${this.props.id}`}
                      />
                    ) : null}
                    <StaigeButton
                      label={i18n.t('camera.addFieldmaskBtn')}
                      style='ghost'
                      icon={plusIcon}
                      iconMargin='0 0 0 -4px'
                      linkTo={`/cameramonitor/liveview/new/${this.props.id}`}
                    />
                  </div>
                </div>

                <div className='column01-list'>
                  {this.renderFieldMaskItem(true, 'Standard')}

                  <div className='list-list'>
                    {!this.state.loadingFields ? (
                      this.state.fieldmasks
                        .filter((field) => field.fieldName !== 'default')
                        .map((field) => {
                          return this.renderFieldMaskItem(false, field.fieldName)
                        })
                    ) : (
                      <div style={{ width: '100%', margin: '40px 0' }}>
                        <AiswSpinner />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className='content-column02'>
                <div className='column02-camera'>
                  <div className='camera-topInfo'>
                    <div className='topInfo-text'>{this.state.camera?.hardwarePlatform}</div>
                    <div className='topInfo-text'>ID {this.state.camera?.RowKey}</div>
                  </div>
                  <div className='camera-field'>
                    {this.state.camera?.address || 'Adresse nicht vorhanden'}
                  </div>
                  <div className='camera-img'>
                    <div className='img-background'>
                      <svg
                        width='327'
                        height='102'
                        viewBox='0 0 327 102'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <mask
                          id='mask0_1608_1492'
                          maskUnits='userSpaceOnUse'
                          x='0'
                          y='0'
                          width='327'
                          height='102'
                        >
                          <rect y='0.517212' width='327' height='101.483' rx='3.75862' fill='#F6F6F6' />
                        </mask>
                        <g mask='url(#mask0_1608_1492)'>
                          <path
                            d='M65.7759 51.0201L22.2832 8.03448L9.39655 21.0912L39.8235 51.1394L9.69485 81.6049L22.7605 94.4828L65.7759 51.0201Z'
                            fill='#151315'
                          />
                          <path
                            d='M114.638 51.0201L71.1453 8.03448L58.2586 21.0912L88.6855 51.1394L58.5569 81.6049L71.6226 94.4828L114.638 51.0201Z'
                            fill='#151315'
                          />
                          <path
                            d='M163.5 51.0201L120.007 8.03448L107.121 21.0912L137.548 51.1394L107.419 81.6049L120.485 94.4828L163.5 51.0201Z'
                            fill='#151315'
                          />
                          <path
                            d='M261.224 51.0201L304.717 8.03448L317.603 21.0912L287.177 51.1394L317.305 81.6049L304.239 94.4828L261.224 51.0201Z'
                            fill='#151315'
                          />
                          <path
                            d='M212.362 51.0201L255.855 8.03448L268.741 21.0912L238.314 51.1394L268.443 81.6049L255.377 94.4828L212.362 51.0201Z'
                            fill='#151315'
                          />
                          <path
                            d='M163.5 51.0201L206.993 8.03448L219.879 21.0912L189.452 51.1394L219.581 81.6049L206.515 94.4828L163.5 51.0201Z'
                            fill='#151315'
                          />
                        </g>
                      </svg>
                    </div>
                    {this.getCamerImg(this.state.camera)}
                  </div>
                  <div className='camera-info'>
                    <div className='info-item'>
                      <div className='item-title'>{i18n.t('camera.cameraInfoTitle')}</div>
                      {this.state.camera?.reachable ? (
                        <StaigeBadge active title='online' color='aqua' />
                      ) : (
                        <StaigeBadge active title='offline' />
                      )}
                    </div>

                    <div className='info-item'>
                      <div className='item-title'>Kalibrierungsstatus</div>
                      {this.state.calibrationLoading ? null : this.state.calibrationStatus ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '4px',
                            alignItems: 'flex-end',
                            textAlign: 'right'
                          }}
                        >
                          <StaigeBadge
                            active
                            title={
                              this.state.calibrationStatus.stitchingStatus.status === 'CALIBRATED'
                                ? 'Kalibriert'
                                : this.state.calibrationStatus.stitchingStatus.status === 'DEGRADED'
                                ? 'Kalibrierungsversatz'
                                : this.state.calibrationStatus.stitchingStatus.status === 'UNCALIBRATED'
                                ? 'Nicht kalibriert'
                                : this.state.calibrationStatus.stitchingStatus.status
                            }
                            color={
                              this.state.calibrationStatus.stitchingStatus.status === 'CALIBRATED'
                                ? 'aqua'
                                : this.state.calibrationStatus.stitchingStatus.status === 'DEGRADED'
                                ? 'yellow'
                                : undefined
                            }
                          />
                          <div
                            style={{
                              fontSize: '10px',
                              color: '#888',
                              marginTop: '2px'
                            }}
                          >
                            Aktualisiert:{' '}
                            {new Date(this.state.calibrationStatus.stitchingStatus.timestamp).toLocaleString(
                              'de-DE'
                            )}
                          </div>
                          <div
                            style={{
                              fontSize: '10px',
                              color: '#aaa'
                            }}
                          >
                            {moment(this.state.calibrationStatus.stitchingStatus.timestamp)
                              .locale('de')
                              .fromNow()}
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            textAlign: 'right'
                          }}
                        >
                          <StaigeBadge active title='Noch nicht kalibriert' color='red' />
                        </div>
                      )}
                    </div>

                    {this.state.camera?.hardwarePlatform?.includes('pluto') ? (
                      <>
                        <div className='info-item'>
                          <div className='item-title'>Aktueller Task</div>
                          {
                            <StaigeBadge
                              active
                              title={cameraStatusDetail?.currentTask ?? 'unknown'}
                              color='white'
                            />
                          }
                        </div>
                        <div
                          style={{
                            background: '#282628',
                            padding: '12px',
                            borderRadius: '2px',
                            width: '100%',
                            fontSize: '10px'
                          }}
                        >
                          {this.state.tasks.length === 0 && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              Keine Aktiven Tasks
                            </div>
                          )}
                          {this.state.tasks.map((task) => {
                            return (
                              <div key={task.gameId}>
                                <div>{task.gameId}</div>
                              </div>
                            )
                          })}
                        </div>
                        <div className='camera-status-panel'>
                          {plutoIndicators.map((item) => (
                            <div className='camera-status-row' key={item.label}>
                              <div className='camera-status-left'>{item.label}</div>
                              <div className='camera-status-right'>
                                <span className={`camera-status-dot camera-status-dot--${item.color}`} />
                                <span className='camera-status-value'>{item.value}</span>
                              </div>
                            </div>
                          ))}
                          {unsyncedServices.length > 0 && (
                            <div className='camera-status-unsynced'>
                              {unsyncedServices.map((service) => (
                                <div key={service.name} className='camera-status-unsynced-item'>
                                  <span>{service.name}</span>
                                  <span>{service.status}</span>
                                </div>
                              ))}
                            </div>
                          )}
                          <div className='camera-status-refresh'>
                            <StaigeButton
                              label={this.state.statusRefreshing ? 'Refresh...' : 'Refresh'}
                              style='secondary'
                              disabled={this.state.statusRefreshing}
                              onClick={this.getCameraStatus}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className='info-item'>
                        <div className='item-title'>Stitching</div>
                        {this.state.camera?.stitching === 'calibrated' ? (
                          <StaigeBadge active title={i18n.t('camera.errorFree')} color='aqua' />
                        ) : (
                          <StaigeBadge active title={i18n.t('camera.check')} />
                        )}
                      </div>
                    )}
                  </div>
                  {this.state.camera?.stitching === 'calibrated' ? null : (
                    <div className='camera-quest'>{i18n.t('camera.camQuest')}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <mobiscroll.Popup ref={this.popup} display='center' buttons={[]}>
          <div className='mbsc-align-center mbsc-padding'>
            <div style={{ fontSize: '20px' }}>{i18n.t('cameraMonito.speedTest.title')}</div>
            <div style={{ margin: '20px 0 0', fontSize: '48px' }}>
              {this.state.speedTestIsRunning ? (
                <div style={{ display: 'inline-block' }}>
                  <AiswSpinner />
                </div>
              ) : (
                <div>
                  <div>{this.state.cameraNetworkSpeed ?? i18n.t('cameraMonito.speedTest.unknown')}</div>
                  <div style={{ fontSize: '28px' }}>{i18n.t('cameraMonito.speedTest.mbps')}</div>

                  {this.state.cameraNetworkSpeed &&
                  !this.state.speedTestIsRunning &&
                  this.state.cameraNetworkSpeed > 10 ? (
                    <div style={{ fontSize: '12px', marginTop: '36px' }}>
                      {i18n.t('cameraMonito.speedTest.infoText')}
                    </div>
                  ) : (
                    <div style={{ fontSize: '12px', marginTop: '36px' }}>
                      {i18n.t('cameraMonito.speedTest.infoTextNot')}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </mobiscroll.Popup>
      </PageWrapper>
    )
  }
}

export default withRouter(CameraMonitor)
